import PowerBiDialog from './PowerBiDialog';

export default PowerBiDialog;
